import { PriorityDiagnosisItemDto } from '@/infra/api/generated/model'

export const toSortedPriorityDiagnoses = (
  priorityDiagnoses: PriorityDiagnosisItemDto[]
): PriorityDiagnosisItemDto[] => {
  return priorityDiagnoses.toSorted(
    (a, b) => getPriorityDiagnosisSortValue(a) - getPriorityDiagnosisSortValue(b)
  )
}

const getPriorityDiagnosisSortValue = (item: PriorityDiagnosisItemDto) => {
  if (item.diagnosis) return 3
  if (item.isExpired) return 2
  return 1
}
